import React, { createContext, useState, useEffect, useMemo } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [items, setItems] = useState([]); // LISTA COMPLETA (Para el Admin)
  const [dbCategories, setDbCategories] = useState([]);
  const [categoriesPromo, setCategoriesPromo] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // --- NUEVA VARIABLE FILTRADA ---
  // Usamos useMemo para que solo se vuelva a filtrar si 'items' cambia.
  // Esta es la que usarás en la Web pública.
  const activeItems = useMemo(() => {
    return items.filter((item) => item.estado !== "pausado");
  }, [items]);

  // 1. CARGAR Y ORDENAR CATEGORÍAS
  const loadCategories = async () => {
    try {
      const response = await fetch(
        "https://optimarketok.com.ar/api/get_categories.php",
      );
      const data = await response.json();

      if (Array.isArray(data)) {
        const sortedCats = data.sort((a, b) =>
          a.nombre.localeCompare(b.nombre),
        );
        setDbCategories(sortedCats);

        const promoList = [
          "redondos",
          "cuadrados",
          "eye cat",
          "lectura",
          "infantiles",
        ];

        setCategoriesPromo(
          sortedCats
            .filter((c) => promoList.includes(c.nombre.toLowerCase()))
            .map((c) => ({ id: c.id, categoria: c.nombre })),
        );

        setCategories(
          sortedCats
            .filter((c) => !promoList.includes(c.nombre.toLowerCase()))
            .map((c) => ({ id: c.id, categoria: c.nombre })),
        );
      }
    } catch (error) {
      console.error("Error cargando categorías de la DB:", error);
    }
  };

  // 2. CARGAR Y ORDENAR PRODUCTOS
  const loadProducts = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://optimarketok.com.ar/api/get_products.php",
      );
      const data = await response.json();

      if (Array.isArray(data)) {
        // Ordenamos los productos de A-Z por título
        const sortedProducts = data.sort((a, b) =>
          a.titulo.localeCompare(b.titulo),
        );
        // Guardamos todo (activos y pausados) para que el Admin los vea
        setItems(sortedProducts);
      }
    } catch (error) {
      console.error("Error cargando productos:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadCategories();
    loadProducts();
  }, []);

  // --- LÓGICA DEL CARRITO ---
  const addToCart = (item) => {
    const itemInCart = cart.find((p) => p.id === item.id);
    if (itemInCart) {
      setCart(
        cart.map((p) =>
          p.id === item.id ? { ...p, cantidad: p.cantidad + 1 } : p,
        ),
      );
    } else {
      setCart([...cart, { ...item, cantidad: 1 }]);
    }
  };

  const clearCart = () => setCart([]);
  const clearProducto = (id) => setCart(cart.filter((p) => p.id !== id));
  const totalCart = () => cart.reduce((acc, p) => acc + p.cantidad, 0);
  const totalPrecio = () =>
    cart.reduce((acc, p) => acc + p.cantidad * p.precio, 0);

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        clearCart,
        clearProducto,
        totalCart,
        totalPrecio,
        items, // <--- Lista total para el ADMIN
        activeItems, // <--- LISTA FILTRADA PARA LA TIENDA
        dbCategories,
        categoriesPromo,
        categories,
        isLoading,
        loadProducts,
        loadCategories,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
